<template>
	<div class="column is-3 is-flex is-flex-direction-column">
		<div class="card">
			<span class="tag poppins-bold" :style="item.img ? '' : 'position: relative;'">
				{{ item.date }}
			</span>
			<div class="admin-actions" v-if="canEdit || canDelete">
				<button v-if="canEdit" class="icon-button" title="Edit" @click="$emit('edit', item)">
					<i class="fas fa-pen"></i>
				</button>
				<button v-if="canDelete" class="icon-button icon-button-delete" title="Delete" @click="$emit('delete', item)">
					<i class="fas fa-trash"></i>
				</button>
			</div>
			<div class="card-image" v-if="item.img">
				<figure class="image is-16by9">
					<img :src="item.img" alt="Placeholder image" />
				</figure>
			</div>
		</div>
		<div class="card-content pb-0">
			<div class="content">
				<p class="title">{{ item.title }}</p>
				<p class="subtitle mb-0" v-if="$route.params.page !== 'tools' && item.author">by {{ item.author }}</p>
				<p class="subtitle desc">{{ item.desc }}</p>
			</div>
		</div>
		<div class="card-footer p-4">
			<a
				v-if="item.downloadLink"
				class="button is-fullwidth poppins-bold"
				:href="item.downloadLink"
				:download="item.downloadFilename || null"
				>Download {{ getDownloadButtonText }}</a
			>
			<span v-else class="button is-fullwidth poppins-bold is-static">No download yet</span>
		</div>
	</div>
</template>

<script>
import auth from '@/auth.js';

export default {
	name: 'SetCard',
	components: {},
	props: ['item'],
	emits: ['edit', 'delete'],
	data() {
		return { auth };
	},
	computed: {
		canEdit() {
			return this.auth.state.isLoggedIn && !!this.item.id;
		},
		canDelete() {
			return this.auth.state.username === 'Admin' && !!this.item.id;
		},
		getDownloadButtonText() {
			if (this.$route.params.page === 'tools') {
				return 'tool';
			} else if (this.$route.params.version) {
				return 'script';
			} else {
				return 'pack';
			}
		},
	},
};
</script>

<style scoped>
.card {
	position: relative;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.card,
.card-content,
.card-footer {
	background-color: #282a32;
}
.card-image .image img {
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}
.card-footer {
	border: none;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
}
.card-content {
	height: 100%;
}
.title {
	padding: 0 0 10px 0;
	font-weight: 500;
	font-style: normal;
	font-size: 1.1rem;
	color: white;
}
.subtitle {
	font-size: 0.8rem;
	line-height: 2;
	font-weight: 500;
	font-style: normal;
	color: #c7c9d2;
}
.desc {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
.button {
	font-size: 0.85rem;
	background-color: #70cb7c;
	color: #131417;
	font-style: normal;
	box-shadow: 0 2px 10px 0px #00000040;
	border-radius: 3px;
	border-color: #70cb7c;
}
.button:hover {
	background-color: #89ce92;
}
.tag {
	background-color: #70cb7c;
	color: #131417;
	padding: 2px 15px;
	border-radius: 20px;
	border-bottom-left-radius: 0;
	display: inline-block;
	font-size: 0.8rem;
	font-style: normal;
	box-shadow: 0 2px 10px 0px #00000040;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
}
.admin-actions {
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 2;
	display: flex;
	gap: 6px;
}
.icon-button {
	width: 28px;
	height: 28px;
	padding: 0;
	margin: 0;
	border: none;
	border-radius: 50%;
	background-color: rgba(19, 20, 23, 0.85);
	color: white;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	font-size: 0.75rem;
	box-shadow: 0 2px 10px 0px #00000040;
	flex-shrink: 0;
}
.icon-button:hover {
	background-color: #70cb7c;
	color: #131417;
}
.icon-button-delete:hover {
	background-color: #e35b5b;
	color: white;
}
</style>
